import React, { useState, useEffect } from "react";
import "./Edituserinformation.css";
import { getUserById, updateUser } from "../../../api/admin/adminApi"; // updateUser API import

const EditUserInformation = ({ user, setShowEdit }) => {
  const [userData, setUserData] = useState(null);
  const [role, setRole] = useState("user");
  const [status, setStatus] = useState("active");
  const [memo, setMemo] = useState("");
  const [privacyConsent, setPrivacyConsent] = useState(false);
  const [marketingConsent, setMarketingConsent] = useState(false);
  const [loading, setLoading] = useState(false);

  // 모달 열릴 때 user.id 기반으로 상세 데이터 불러오기
  useEffect(() => {
    if (user?.id) {
      getUserById(user.id).then((data) => {
        setUserData(data);
  
        // 🔥 ROLE_ADMIN + ROLE_SUPERUSER 모두 같은 등급으로 처리
        const isAdmin =
          data.roleName === "ROLE_ADMIN" || data.roleName === "ROLE_SUPERUSER";
        setRole(isAdmin ? "admin" : "user");
  
        setStatus(
          data.approvalStatusDescription === "승인완료"
            ? "active"
            : "inactive"
        );
        setMemo(data.memo || "");
        setPrivacyConsent(data.privacyConsent);
        setMarketingConsent(data.marketingConsent);
      });
    }
  }, [user]);
  

  const handleClose = () => {
    setShowEdit(false);
  };

  const handleSave = async () => {
    if (!userData) return;

    setLoading(true);
    try {
      const payload = {
        ...userData,
        roleName:
          role === "admin"
            ? "ROLE_ADMIN"
            : role === "superuser"
            ? "ROLE_SUPERUSER"
            : "ROLE_USER",
        approvalStatusDescription: status === "active" ? "승인완료" : "승인거부",
        memo,
        privacyConsent,
        marketingConsent,
      };
    

      const res = await updateUser(userData.id, payload);
      console.log("유저 정보 수정 성공:", res.data);

      alert("유저 정보가 성공적으로 수정되었습니다.");
      handleClose();
    } catch (error) {
      console.error("유저 정보 수정 실패:", error);
      alert("유저 정보 수정 중 오류가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  };

  if (!userData) {
    return (
      <div className="Edituserinformation_Container">
        <div style={{ color: "#fff" }}>불러오는 중...</div>
      </div>
    );
  }

  return (
    <div className="Edituserinformation_Container">
      <div className="Edituserinformation_TitleBox">사용자 정보 수정</div>

      {/* 이름 */}
      <div className="Edituserinformation_NameContainer">
        <div className="Edituserinformation_NameBox">이름</div>
        <input
          type="text"
          className="Edituserinformation_NameTextFelid"
          value={userData.name || ""}
          onChange={(e) =>
            setUserData({ ...userData, name: e.target.value })
          }
        />
      </div>

      {/* 이메일 */}
      <div className="Edituserinformation_NameContainer">
        <div className="Edituserinformation_NameBox">이메일</div>
        <input
          type="text"
          className="Edituserinformation_NameTextFelid"
          value={userData.userId || ""}
          onChange={(e) =>
            setUserData({ ...userData, userId: e.target.value })
          }
        />
      </div>

      {/* 전화번호 */}
      <div className="Edituserinformation_NameContainer">
        <div className="Edituserinformation_NameBox">전화번호</div>
        <input
          type="text"
          className="Edituserinformation_NameTextFelid"
          value={userData.tel || ""}
          onChange={(e) =>
            setUserData({ ...userData, tel: e.target.value })
          }
        />
      </div>

      {/* 권한 / 상태 */}
      <div className="Edituserinformation_ActivityContainer">
        <div className="Edituserinformation_AuthorityBox">
          권한
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            className="custom-select"
          >
            <option value="user">일반 사용자</option>
            <option value="admin">관리자</option>
          </select>
        </div>

        <div className="Edituserinformation_ActivityBox">
          상태
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className={`custom-select ${
              status === "active" ? "active-text" : "inactive-text"
            }`}
          >
            <option value="active">활성</option>
            <option value="inactive">비활성</option>
          </select>
        </div>
      </div>

      {/* 메모 */}
      <div className="Edituserinformation_MemoContainer">
        <div className="Edituserinformation_NameBox">메모</div>
        <input
          type="text"
          className="Edituserinformation_MemoTextFelid"
          value={memo}
          onChange={(e) => setMemo(e.target.value)}
        />
      </div>

      {/* 동의 여부 */}
      <div className="Edituserinformation_AgreeContainer">
        <div style={{display:'flex'}}>
          개인정보 동의 여부
          {/* <input
            type="radio"
            checked={privacyConsent}
            onChange={() => setPrivacyConsent(true)}
          /> */}
          <div style={{display:'flex'}}>
          <div className='custom-checkbox-wrapper'>
            <label className='custom-checkbox'>
              <input type='checkbox'checked={privacyConsent}
            onChange={() => setPrivacyConsent(true)} style={{opacity:"0", width:"0.1px"}}/>
              <span className='checkmark' />
              
            </label>
            동의
          </div>
         
          <div className='custom-checkbox-wrapper'>
            <label className='custom-checkbox'>
              <input type='checkbox'checked={!privacyConsent}
            onChange={() => setPrivacyConsent(false)} style={{opacity:"0", width:"0.1px"}}/>
              <span className='checkmark' />
              
            </label>
            미동의
          </div>
          {/* <input
            type="radio"
            checked={!privacyConsent}
            onChange={() => setPrivacyConsent(false)}
          /> */}
         
        </div>

          </div>
          
        <div>
          마케팅 동의 여부
          <input
            type="radio"
            checked={marketingConsent}
            onChange={() => setMarketingConsent(true)}
          />
          동의
          <input
            type="radio"
            checked={!marketingConsent}
            onChange={() => setMarketingConsent(false)}
          />
          미동의
        </div>
      </div>

      {/* 버튼 */}
      <div className="Edituserinformation_BtnContainer">
        <div
          className={`Edituserinformation_Btn ${loading ? "disabled" : ""}`}
          onClick={handleSave}
        >
          {loading ? "저장 중..." : "저장"}
        </div>
        <div className="Edituserinformation_Btn" onClick={handleClose}>
          취소
        </div>
      </div>
    </div>
  );
};

export default EditUserInformation;
